<div class="w-full max-w-7xl items-center">
  <section class="mt- mb-8 flex lg:mb-0">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
    >
      <!-- Comcast Business | Nitel Logo -->
      <div class="flex items-center justify-center">
        <a routerLink="/" class="inline-block" title="Go to homepage">
          <img
            src="assets/images/logos/comcast_bussiness_nitel_logo.png"
            alt="Comcast Business | Nitel Logo"
            class="h-24 w-auto lg:h-28"
          />
        </a>
      </div>

      <!-- Title -->
      <h2 class="mt-4 font-montserrat text-lg font-bold text-black lg:text-2xl">
        Forgot your Password?
      </h2>

      @if (displayForm()) {
        <div class="my-4 flex font-lato text-base">
          Enter the username registered with Nitel and a link will be sent to
          you to reset your password.
        </div>

        <form
          [formGroup]="forgotPasswordFormGroup"
          novalidate
          (ngSubmit)="submitForgotPasswordForm()"
        >
          <label for="username" class="comcast-input-label">Username</label>
          <input
            formControlName="username"
            id="username"
            type="text"
            required
            name="username"
            autocomplete="username"
            [attr.aria-invalid]="errorMessage()?.length ? 'true' : 'false'"
            [ngClass]="{
              'comcast-input-invalid': errorMessage()?.length > 0,
            }"
            class="comcast-input"
            placeholder="Enter your username"
          />
          <div
            class="comcast-validation-error"
            [ngClass]="{ hidden: !errorMessage()?.length }"
          >
            {{ errorMessage() }}
          </div>
          <div class="mt-6 flex">
            <button type="submit" [disabled]="isLoading()" class="btn-primary">
              @if (isLoading()) {
                <div class="flex min-w-16 justify-center">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              } @else {
                SEND
                <mat-icon
                  class="flex !h-[18px] !align-middle !text-[18px] !leading-none"
                  >mail</mat-icon
                >
              }
            </button>
          </div>

          <div
            class="mt-4 flex justify-center font-lato text-sm lg:justify-start"
          >
            Need Help? Call us at&nbsp;
            <a href="tel:8884502100">888-450-2100</a>
          </div>
        </form>
      } @else {
        <div class="mt-4 flex font-lato text-base">
          If an account exists for that username, you'll receive an email with
          instructions to reset your password.
        </div>
        <div class="mt-6 flex">
          <a
            routerLink="/login"
            title="Go back to login to MyPortal"
            class="btn-primary"
          >
            Ok
          </a>
        </div>
      }
    </div>
  </section>
</div>
